import { Component, Input } from '@angular/core';

@Component({
  selector: 'axis-columns',
  templateUrl: './columns.component.html'
})
export class ColumnsComponent {
 @Input() columnCount = '';
 @Input() separator = true;
 @Input() dataProvider = [];
  constructor() { }
}

@Component({
  selector: 'axis-columns-list',
  template: '<li><ng-content></ng-content></li>'
})
export class ColumnsListComponent {}
